import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_ADMIN_DASHBOARD_TEAM_CONTRIBUTION';

export async function getTeamContribution(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getTeamContribution - Start');

        const getTeamContribution = await DashboardService.AdminService.getTeamContribution(userData, params);

        LoggerService.logInfo('Action - getTeamContribution - End - Success');

        return ResultModel.newSuccessResult(getTeamContribution);
    }
    catch (error) {
        LoggerService.logInfo('Action - getTeamContribution - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
